import { useContext, useEffect } from 'react'

import { useAudioPlayer } from 'react-use-audio-player'

import { AppContext } from 'state/appContext'

import { analyticsPlayers, track } from './analytics'
import {
  ArticleAudioPlayerState,
  PlayerAnalyticsDataLayerEventVoiceType,
} from './types'

type Props = {
  articleId: number
  url: string
  setAudioPlayerState: (state: ArticleAudioPlayerState) => void
}

export function Player({ url, setAudioPlayerState, articleId }: Props) {
  const {
    state: { articlePlayingId },
  } = useContext(AppContext)

  const { playing, pause, duration } = useAudioPlayer({
    src: url,
    format: 'mp3',
    autoplay: true,
    onplay: () => {
      setAudioPlayerState('playing')
      track(articleId, 'play')
    },
    onpause: () => {
      setAudioPlayerState('paused')
      track(articleId, 'pause')
    },
    onend: () => {
      setAudioPlayerState('ended')
      track(articleId, 'finished')
    },
  })

  useEffect(() => {
    const voiceType: PlayerAnalyticsDataLayerEventVoiceType = 'female'
    const analyticsPlayer = analyticsPlayers[articleId]
    if (
      duration > 0 &&
      (!analyticsPlayer || analyticsPlayer.voiceType !== voiceType)
    ) {
      analyticsPlayers[articleId] = {
        postId: articleId,
        voiceType,
        duration,
        currentTime: 0,
      }
    }
  }, [articleId, duration])

  useEffect(() => {
    if (playing && articleId !== articlePlayingId) {
      pause()
    }
  }, [articleId, articlePlayingId, playing, pause])

  return null
}
